export const labelsCriteriosRemuneracao = {
  valorNominalUnitarioEmissao: 'Valor Nominal Unitário de Emissão',
  quantidadeEmitida: 'Quantidade emitida',
  volumeEmissao: 'Volume de Emissão',
  quantidadeDepositada: 'Quantidade Depositada na Laqus',
  moedaEmissao: 'Moeda de Emissão',
  dataEmissao: 'Data Emissão',
  dataVencimento: 'Data Vencimento',
  cotacaoInicial: 'Cotação inicial',
  dataInicioRentabilidade: 'Data Início Rentabilidade',
  inicioRentabilidade: 'Quando será o início da rentabilidade?',
  indexador: 'Indexador',
  indexadorPorcentagem: '% Indexador',
  defasagemFixing: 'Defasagem/Fixing',
  periodicidadeCorrecao: 'Periodicidade de Correção',
  proRata: 'Pro-rata',
  corrigePeriodoFinal: 'Corrige Período Final?',
  diaAniversario: 'Dia de Aniversário',
  mesAniversario: 'Mês de Aniversário',
  tipoProjecao: 'Tipo de Projeção',
  taxaJurosFixoSpreadPorcentagem: 'Taxa de Juros Fixo/Spread %',
  convencao: 'Convenção',
  cpfCnpjInvestidor: 'CPF/CNPJ Investidor',
  quantidade: 'Quantidade',
  volumeTotal: 'Volume Total',
  banco: 'Banco',
  agencia: 'Agência',
  conta: 'Conta',
  investidores: 'Investidores',
  custoTotal: 'Custo Total',
  feeLaqusBruto: 'Fee Laqus Bruto',
  feeLaqusLiquido: 'Fee Laqus Líquido',
  feeRepasse: 'Fee Repasse',
};

export const labelsEventosFinanceiros = {
  pagamentoAmortizacao: 'Pagamento de Amortização',
  percentualAmortizacaoSobre: 'Percentual de Amortização sobre',
  percentualAmortizacaoPassivelAlteracao:
    'Percentual de Amortização passível de alteração e sujeito à disponibilidade de recursos previsto no Termo de Securitização?',
  percentualAmortizacao: '% da Amortização',
  dataAmortizacao: 'Data da Amortização',
  pagamentoJuros: 'Pagamento de Juros',
  dataPagamentoJuros: 'Data de Pagamento de Juros',
  incorporacaoJuros: 'Incorporação de Juros',
  dataIncorporacaoJuros: 'Data de Incorporação de Juros',
  resgateAntecipadoFacultativo: 'Apresenta Resgate Antecipado Facultativo?',
  modalidadeAmortizacao: 'Modalidade de Amortização',
};